// extracted by mini-css-extract-plugin
module.exports = {"faxDetails":"styles_faxDetails__2TFx3","detailsBorder":"styles_detailsBorder__3wweO"};